import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaProperty } from "../Schema";
import { NotEmptyString } from "../../../../Validation/Validation";

export const PrefixSchema: ISchema = {
    displayName: "Prefix",
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'value',
            displayName: 'Value',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            className: "small-12",
            validateRule: NotEmptyString as Function,
            validationError: "Value cannot be empty",
        } as ISchemaProperty
    ],
}


